import {Card} from './Card'

function getLowCard(cards: Card[], trump: Card): Card | null {
    let lowCard = null
    let lowWeight = 10e3

    for (let i = 0; i < cards.length; i++) {
        let card = cards[i]
        let weight = card.weight(trump)

        if (weight < lowWeight) {
            lowWeight = weight
            lowCard = card
        }
    }
    return lowCard
}

export default getLowCard
